import React, { useEffect, useState } from 'react';

function filterByValue (key, val) {
    return function (item) {
        return item.attributes[key] == val;
    }
}

function intersect( first_array , second_array ){
    return first_array.filter( x => second_array.includes( x ) );
}

function isempty( myarray ){
    return myarray === undefined || myarray.length == 0 ;
}

function joinFacilities( validFacilitiesIds, facilitiesSubgroup ){

    if ( !isempty ( validFacilitiesIds ) && !isempty( facilitiesSubgroup ) ){

        return intersect( validFacilitiesIds, facilitiesSubgroup );

    }else if ( isempty( facilitiesSubgroup ) ){

        
        return [];

    }

    return validFacilitiesIds;

}

export default function (filters = {}, facilities=[], facility_season = [], facility_dow = [], facility_timeofday = []  ) { //Add the object as attribute to use its data and filtered
    
    let resultValidFacilities = [];

    function fetch () {

        let validFacilities = facilities;
        let validSeasonFacilities = [];
        let validDowFacilities = [];
        let validTimeFacilities = [];

        if ( filters.season ) {
            facility_season.forEach( ({ id,season }) =>{
                   
                    if( season === filters.season ){
                            
                        if ( !validSeasonFacilities.includes( id ) ){
     
                            validSeasonFacilities.push( id );
    
                        }
                        
                    }

            });

            validFacilities = joinFacilities( validFacilities, validSeasonFacilities );
        }

        

        if ( filters.dow ) {

            facility_dow.forEach(  ({ id, dow })  => {
    
                dow.split(",").forEach( dow => {
    
                    filters.dow.split(",").forEach( filter_dow =>{

                        if( dow === window.DAYS_OF_WEEK[ filter_dow ]  ){
                            
                            if ( !validDowFacilities.includes( id ) ){
         
                                validDowFacilities.push( id );
        
                            }
                            
                        }
                    });
                    
                });
            }); 
            
            validFacilities = joinFacilities( validFacilities, validDowFacilities );
            
            
        }

        if ( filters.time ) {
    
            facility_timeofday.forEach(  ({ id, timeofday })  => {
                
                filters.time.split(",").forEach( filter_timeofday =>{
    
                    if( timeofday === window.TIMES_OF_DAY[ filter_timeofday ]  ){
                            
                        if ( !validTimeFacilities.includes( id ) ){
        
                            validTimeFacilities.push( id ); 
        
                        }
                            
                    }
    
                });           
                
            });
            
            validFacilities = joinFacilities( validFacilities, validTimeFacilities );

        }
        

        resultValidFacilities =  validFacilities; 
    }

    fetch();    

    return resultValidFacilities;
}
